
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/player/[...slug]",
      function () {
        return require("private-next-pages/player/[...slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/player/[...slug]"])
      });
    }
  